import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";

const formatViews = (views) =>
  views >= 10000 ? `${(views / 10000).toFixed(1)}만회` : `${views.toLocaleString("ko-KR")}회`;

const VideoComponent = ({ title, subtitle, layout, items = [] }) => {
  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-video cms-video--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-video__item">
            <div className="cms-video__thumb">
              <img src={item.img} alt={item.title} />
              <span className="cms-video__play">▶</span>
              <span className="cms-video__duration">{item.duration}</span>
            </div>
            <div className="cms-video__body">
              <h5 className="cms-video__title">{item.title}</h5>
              <p className="cms-video__desc">{item.description}</p>
              <span className="cms-video__views">조회수 {formatViews(item.views)}</span>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default VideoComponent;
